import React from 'react'
import {Button, Card, CardActions, CardContent, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";

type StyleProps = {
    variant: any;
}

const useStyles = makeStyles<Theme, StyleProps>({
    card: {
        width: 270,
        height: 200
    },
    header: {
        height: '70%',
        display: 'flex',
        textAlign: 'center',
        color: 'white',
        background: props => props.variant,
        wordBreak: 'break-all',
        position: 'relative',
        padding: '0'
    },
    headerGradient: {
        position: 'absolute',
        background: 'linear-gradient(to right, rgba(0,0,0,0.2) 0%,rgba(0,0,0,0) 100%)',
        width: '100%',
        height: '100%',
        zIndex: 1
    },
    headerTitle: {
        fontSize: '1rem',
        flexGrow: 1,
        textAlign: 'left',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 5px 2px 10px',
        zIndex: 2,
        overflow: 'hidden'
    },
    action: {
        height: '30%',
        justifyContent: 'flex-end',
        cursor: 'pointer'
    },
    selectButton: {
        height: '30%',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
});

function OrganizationCard({organization, variant, onSelect, ...props}: any) {
    const {t} = useTranslation();
    const classes = useStyles({variant});
    const alreadySelected = props.selected?.id === organization.id;

    return (
        <Card className={classes.card}>
            <CardContent className={classes.header}>
                <div className={classes.headerGradient}></div>
                <div className={classes.headerTitle}>
                    {organization.name}
                </div>
            </CardContent>
            <CardActions className={classes.action} onClick={() => !alreadySelected && onSelect(organization)}>
                <Button variant="text"
                        disabled={alreadySelected}
                        color="primary" size="large"
                        className={classes.selectButton}>
                    {alreadySelected ? t('_Common.Labels.Selected') : t('_Common.Labels.Open')}
                </Button>
            </CardActions>
        </Card>
    )
}

export default OrganizationCard
